import React, { useEffect } from 'react'
import NaveBar from '../composant/NaveHero/NaveBar'
import Footer from '../composant/Footer'
import MainContainerAdhesion2 from '../composant/MainContainerAdhesion2'


const Contacts = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <div>
       <NaveBar />
      
       <MainContainerAdhesion2 />


       <Footer />
    </div>
  )
}

export default Contacts
